import { reviewList } from './request';
import { customerResource } from './../../system/customerManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import seeReviewModel from './seeReviewModel.vue';
export default {
  components: {
    seeReviewModel
  },
  data() {
    return {
      seeReviewShow: false,
      customerList: [],
      applicationList: [],
      data: [],
      form: {
        applicationId: undefined
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: '发布客户'
        },
        dataIndex: 'customerName',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '发布应用'
        },
        dataIndex: 'applicationName',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '版本号'
        },
        dataIndex: 'versionNumber',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '上线平台'
        },
        dataIndex: 'platform',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '优化内容'
        },
        dataIndex: 'content',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: '7',
        align: 'center'
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: '8',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        key: '9',
        align: 'center',
        width: 100
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.getDataFun();
    customerResource().then(res => {
      this.customerList = res;
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      reviewList(obj).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    applicationFun() {
      this.form.applicationId = undefined;
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleSee(val) {
      this.seeReviewShow = true;
      this.$nextTick(() => {
        this.$refs.seeReviewFrom.init(val);
      });
    },
    handleOk() {
      this.searchFun();
      this.$emit('ok');
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTableFun();
    }
  }
};